module.exports = __webpack_public_path__ + "img/login-logo.c3ee57d2.png";